module.exports = __webpack_public_path__ + "img/banner-home.36cf5856.png";